import { BasePage } from '@/components/ui/base-page'

export function REITsPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add REITsPage specific content here */}
    </BasePage>
  )
}